export type SocialUrlField = 'facebookUrl' | 'instagramUrl' | 'youtubeUrl';

export const SOCIAL_URL_CONFIG: Record<
  SocialUrlField,
  { displayPrefix: string; matchPrefixes: string[]; placeholder: string }
> = {
  facebookUrl: {
    displayPrefix: 'https://facebook.com/',
    matchPrefixes: [
      'https://www.facebook.com/',
      'https://facebook.com/',
      'http://www.facebook.com/',
      'http://facebook.com/',
    ],
    placeholder: 'your-page',
  },
  instagramUrl: {
    displayPrefix: 'https://instagram.com/',
    matchPrefixes: [
      'https://instagram.com/',
      'https://www.instagram.com/',
      'http://instagram.com/',
      'http://www.instagram.com/',
    ],
    placeholder: 'your-handle',
  },
  youtubeUrl: {
    displayPrefix: 'https://youtube.com/',
    matchPrefixes: [
      'https://youtube.com/',
      'https://www.youtube.com/',
      'http://youtube.com/',
      'http://www.youtube.com/',
    ],
    placeholder: '@your-channel',
  },
};

export function getSocialUrlSuffix(fullUrl: string, matchPrefixes: string[]): string {
  const trimmed = fullUrl.trim();
  if (!trimmed) return '';

  const lower = trimmed.toLowerCase();
  for (const prefix of matchPrefixes) {
    if (lower.startsWith(prefix.toLowerCase())) {
      return trimmed.slice(prefix.length);
    }
  }

  return trimmed;
}

export function buildSocialUrl(displayPrefix: string, suffix: string): string {
  const trimmedSuffix = suffix.trim();
  if (!trimmedSuffix) return '';

  if (/^https?:\/\//i.test(trimmedSuffix)) {
    return trimmedSuffix;
  }

  return `${displayPrefix}${trimmedSuffix.replace(/^\/+/, '')}`;
}
